<template>
<div class="inner-wrapper">
   <!--<div class="page-title">
      <h1 class="float-left">Vendor Bags</h1>
      <div class="title-right float-right">
         
      </div>
   </div>-->
      <div class="new-rfq">
      <fieldset class="customer-search mb-3">
               <div class="row">
                    <div class="col-sm-6 col-md-6">
                        <form class="form-inline" action="">
                            <div class="form-group">
                                <select class="form-control" @change="getCustomers" v-model="filterForm.status_filter">
                                    <option value="">All</option>
                                    <option value="1">Active</option>
                                    <option value="2">Inactive</option>
                                </select>
                            </div>
                            <div class="input-group quick-search">
                                <div class="listsearch-box">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary" @click="getCustomers" type="button"><i class="ri-search-line search-icon"></i></button>
                                    </div>
                                    <input  v-model="filterForm.search_filter" type="text" class="form-control" placeholder="Quick Search">
                                </div>
                            </div>                            
                        </form>
                    </div>
                    <div class="col-sm-6 col-md-6">
                        <div class="btnrow float-right">
                            <a href="javascript:void(0)" @click="addVendorBag()" class="btn create-btn">
                             Create Vendor Bag
                            </a>
                        </div>
                    </div>
               </div>
            </fieldset>
        <div class="mb-4 row">
            
            <div class="col-lg-12 col-md-12">
                <div class="card panel ">
                    <div class="card-header headnbtn">
                        <h5 class="card-title mb-0">List of Vendor Bags</h5>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive product-create table-card">
                            <table class="table table-nowrap table-bordered align-middle mb-0 table-custom">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Bag Name</th>
                                    <th>Date Added</th>
                                    <th>Date Updated</th>
                                    <th>Status</th>
                                    <th style="width: 100px">Action </th>
                                </tr>
                            </thead>
                            <template v-for="(customer, index) in vendorBags.data">
                                <tr :id="customer.id">
                                    <td>{{ index+1 }}</td>
                                    <td>{{customer.bag_name}}</td>
                                    <td>{{formatDate(customer.created_at)}}</td>
                                    <td>{{formatDate(customer.updated_at)}}</td>
                                    <td><a href="#" :class="[customer.status=='1' ? 'btn active-btn':'btn inactive-btn']" >{{(customer.status=='1')?'Active':'Inactive'}}</a></td>
                                    <td>
                                        <a class="edit-btn" href="javascript:void(0);" @click="updateModal(customer.id)" style="font-size: 18px;"><i class="ri-edit-fill me-1"></i></a>
                                        <a  href="javascript:void(0);" @click="showDelete(customer.id)" class="del_btn trash-btn" title="Delete Customer" :data-id="customer.id"><i class="ri-delete-bin-6-line"></i></a>
                                    </td>
                                </tr>
                            </template>
                            </table>
                        </div>
                        
                        <div class="btnrow card-btn mt-3">
                            <template>
                            <div class="overflow-auto">
                                <b-pagination
                                v-model="current_page"
                                :total-rows="total"
                                :per-page="per_page"
                                ></b-pagination>

                                <!-- <p class="mt-3">Current Page: {{ current_page }}</p> -->

                                
                            </div>
                            </template>
                        </div>
                    </div>
                </div>

                
            </div>
        </div>
            

            
      </div>

    <!-- Add Vendor Bag  -->

    <div id="updateVendor" class="modal fade quote-popup">
        <div class="modal-dialog modal-confirm">
            <div class="modal-content">
            <ValidationObserver v-slot="{ handleSubmit }">
            <form  @submit.prevent="updateBag" id="addCustomerForm" name="addCustomerForm" method="post">
            <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                <strong class="success_msg">{{successMessage}}</strong>
            </div>
            <div class="alert alert-danger succ_msg" v-if="errorMessage !=null">
                <strong class="success_msg">{{errorMessage}}</strong>
            </div>
             <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                <ul>
                    <li v-for="(v, k) in commonErrors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                    {{ error }}
                    </p>
                    </li>
                </ul>
            </div>
                <div class="modal-header bg-soft-info p-3">
                   
                    <h4 class="modal-title">Create Vendor Bag</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="ri-close-line"></i></button>
                </div>
                <div class="modal-body">
                   <div class="form-group">
                   <validation-provider rules="required" v-slot="{ errors }">
                        <label for="name">Name:</label>
                        <input type="text" class="form-control" id="name" v-model="form.bag_name">
                        <span class="error">{{ errors[0] }}</span>
                    </validation-provider>
                    </div>
                    <div class="form-group">
                    <validation-provider rules="required" v-slot="{ errors }">
                        <label for="pwd">Status:</label>
                        <select class="form-control mdl-textfield__input" id="status" name="status" v-model="form.status">
                                    <option value="1">Active</option>
                                    <option value="2">InActive</option>
                        </select>
                        <span class="error">{{ errors[0] }}</span>
                    </validation-provider>
                    </div>
                    <div class="btnrow text-right">
                        <button type="button" class="btn btn-danger me-1" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                </div>
                <input type="hidden" name="delete_id" id="delete_id" value="">
                
            </form>
            </ValidationObserver>
            </div>
        </div>
    </div>



    <div id="createVendor" class="modal fade quote-popup">
        <div class="modal-dialog modal-confirm">
            <div class="modal-content">
           <ValidationObserver v-slot="{ handleSubmit }">
            <form  @submit.prevent="handleSubmit(save)" id="addCustomerForm" name="addCustomerForm" method="post">
             <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                <strong class="success_msg">{{successMessage}}</strong>
            </div>
            <div class="alert alert-danger succ_msg" v-if="errorMessage !=null">
                <strong class="success_msg">{{errorMessage}}</strong>
            </div>
             <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                <ul>
                    <li v-for="(v, k) in commonErrors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                    {{ error }}
                    </p>
                    </li>
                </ul>
            </div>
                <div class="modal-header bg-soft-info p-3">
                    
                    <h4 class="modal-title">Create Vendor Bag</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="ri-close-line"></i></button>
                </div>
                <div class="modal-body">
                   <div class="form-group">
                   <validation-provider rules="required" v-slot="{ errors }">
                        <label for="name">Name:</label>
                        <input type="text" class="form-control" id="name" v-model="form.bag_name">
                        <span class="error">{{ errors[0] }}</span>
                    </validation-provider>
                    </div>
                    <div class="form-group">
                    <validation-provider rules="required" v-slot="{ errors }">
                        <label for="pwd">Status:</label>
                        <select class="form-control mdl-textfield__input" id="status" name="status" v-model="form.status">
                                    <option value="1">Active</option>
                                    <option value="2">InActive</option>
                        </select>
                        <span class="error">{{ errors[0] }}</span>
                    </validation-provider>
                    </div>
                    <div class="btnrow text-right">
                        <button type="button" class="btn btn-danger me-1" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                </div>
                <input type="hidden" name="delete_id" id="delete_id" value="">
                
            </form>
            </ValidationObserver>
            </div>
        </div>
    </div>


    <!-- End Vendor Bag -->
      <!-- Delete Modal HTML -->
    <div id="deleteModal" class="modal fade delete-modal">
        <div class="modal-dialog modal-confirm">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i class="ri-close-line"></i></button>
                </div>
                <div class="modal-body text-center">
                    <div class="trashbtn"><i class="ri-delete-bin-6-line"></i></div>
                    <h4 class="inr-title">Are you sure?</h4>
                    <p>Do you really want to delete these records? This process cannot be undone.</p>
                    <div class="btnrow">
                        <button type="button" class="btn btn-primary  me-1" data-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-danger confirm_delete" @click="deleteCustomer()">Delete</button>
                    </div>
                </div>
                <input type="hidden" name="delete_id" id="delete_id" value="">
                
            </div>
        </div>
    </div>
            
   <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        2022 © Superb.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-right d-none d-sm-block">
                            All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
</div>
</template>

<script>
import { ValidationObserver,ValidationProvider, extend,validate  } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

// with typescript
for (let [rule, validation] of Object.entries(rules)) {
  extend(rule, {
    ...validation
  });
}
export default {
    name: "VendorBag",
     components: {
        ValidationProvider,ValidationObserver 
    },
    created() {
         if(localStorage.getItem('token')){
             console.log("token "+localStorage.getItem('token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
        }
        this.getCustomers();
    },
    data(){
        return {
            vendorBags: {
               data:[],
               config: null,
                
            },
            current_page:1,
            per_page:10,
            total:0,
            filterForm: {
                search_filter: null,
                status_filter: ''
            },
            form:{
                id:null,
                bag_name:null,
                status:null
            },
            showModal: false,
            deleteId: null,
            csv_file: null,
            uploadPercent: 0,
            showUploadProgress: false,
            processingUpload: false
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        // updatePagination(){
        //     if(this.current_page != 1){
        //         this.getCustomers();
        //     }
        // },
        updateBag(){

                
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.put(window.route('vendor-bag.update', {id: this.form.id}), this.form, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        $('#updateVendor').modal('hide');
                        self.getCustomers();
                        // self.setSuccessMessage(data.data);
                        // self.getCustomer();
                        // self.$router.push({ name: 'viewCustomers' });
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });

        },

        save() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('vendor-bag.store'), this.form,{
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                        console.log("Errors ",this.commonErrors);
                        for(var i = 0;i< this.commonErrors.length;i++){
                            console.log("Errors inside ");
                        }
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.customerData = data.data;
                        $('#createVendor').modal('hide');
                        this.getCustomers();
                            this.form =  {
                                bag_name: null,
                               status:null
                           
                            };

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },

        getCustomers() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('vendor-bag.index',{page: this.current_page,search_filter:this.filterForm.search_filter,status_filter:this.filterForm.status_filter} ), {
                
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    console.log(data);
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.vendorBags = data.data.vendorBags;
                         this.current_page = data.data.vendorBags.current_page;
                        this.per_page = data.data.vendorBags.per_page;
                        this.total = data.data.vendorBags.total;
                        //this.setCustomers(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getSLNo(index) {
            return Number(this.vendorBags.config['start_from']) + index;
        },
        handleFileUpload(){
            this.csv_file = this.$refs.csv_file.files[0];
        },
        addVendorBag(){
            $('#createVendor').modal('show');
        },
        updateModal(id){
            let self = this;
            this.form.id  = id;
            console.log("id",this.form.id);

            
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('vendor-bag.show',this.form.id), {
                
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
            .then(({ data }) => {
                console.log(data);
                if(data.errors){
                    self.setCommonErrors(data.errors);
                } else if(data.errorMessage){
                    self.setErrorMessage(data.errorMessage);
                } else {

                    console.log(data.data);
                     this.form =  {
                                id:data.data.id,
                                bag_name: data.data.bag_name,
                               status:data.data.status
                           
                            };

                    $('#updateVendor').modal('show');
                    // this.vendorBags = data.data.vendorBags;
                    // this.current_page = data.data.vendorBags.current_page;
                    // this.per_page = data.data.vendorBags.per_page;
                    // this.total = data.data.vendorBags.total;
                    //this.setCustomers(data.data);
                }
            })
            .catch((error) => {
                self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

            })
            .finally(() => {
                self.setCustomerLoading(false);

            });


            
        },
        showDelete(id) {
            this.deleteId = id;
            $('#deleteModal').modal('show');
        },
        hideDelete() { $('#deleteModal').modal('hide'); this.deleteId = null; },
        deleteCustomer() {
            if(this.deleteId) {
                let self = this;
                this.setCustomerLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.delete(window.route('vendor-bag.destroy', {id: this.deleteId}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({ data }) => {
                        if(data.errors){
                            self.setCommonErrors(data.errors);
                        } else if(data.errorMessage){
                            self.setErrorMessage(data.errorMessage);
                        } else {
                            self.setSuccessMessage(data.data);
                            self.deleteId = null;
                             $('#deleteModal').modal('hide');
                            self.getCustomers();
                           
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setCustomerLoading(false);

                    });
            }
        }
    },
    mounted(){
        let self = this;
        $('#updateVendor').on('hidden.bs.modal', function () {
            self.form ={
                id:null,
                bag_name:null,
                status:null
            }
        })
    },
    watch: {
        current_page: {
        handler: function(value) {
            this.getCustomers();
            console.log("watch ",value);
        }
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>

</style>
